export const actions = {
    setNumberToCall({ commit }, numberToCall) {
        commit('SET_NUMBER_TO_CALL', JSON.parse(JSON.stringify(numberToCall)))
    },
    emptyNumberToCall({ commit }) {
        commit('EMPTY_NUMBER_TO_CALL')
    },

};
